export const getLayout = (layout: string): 'mobile' | undefined => {
  return layout === 'mobile' ? 'mobile' : undefined;
};
